import ApiWrapper from '../api/cellWineApi'
import * as wineActions from './wines'
import { fromJS } from 'immutable';

const initWineListFilter = {
    country: undefined,  //country code(separated by commas)
    region: undefined,  // region id(separated by commas)
    minValue: undefined,  // minimum wine value
    maxValue: undefined,  // maximum wine value
    color: undefined,  // red / white / rose / others(separated by commas)
    style: undefined,  // still / sparkling / fortified / dessert(separated by commas)
    maxVintage: undefined,  // maximum wine vintage
    minVintage: undefined,  // minimum wine vintage
    isIncludeNV: undefined,  // is wine vintage include NV, 1: yes / 0: no
    volume: undefined,  // wine volume, (separated by commas)(if include 3000 will return the wine volume more than 3000)
    orderBy: undefined,  // update / value / PAL(profit and loss)
    order: undefined,  // DESC / ASC
}

const getMemberWineNoteMap = (latestActivity) => {
	const obj = {}
	latestActivity.forEach(memberWine => {
		obj[memberWine.memberWineId] = memberWine.note
	})
	return obj
}

const updateMemberWineNote = (wineList, latestActivity) => {
	let newWineList = fromJS(wineList)
	const memberWineNoteMap = fromJS(getMemberWineNoteMap(latestActivity))
	let updater = newWineList.get('wines').map(item => {
		const newMemberWine = item.get('storageMemberWine').map(memberWine => {
			memberWine = memberWine.set('note', memberWineNoteMap.get(memberWine.get('memberWineId').toString()))
			return memberWine
	    })
		item = item.set('storageMemberWine', newMemberWine)
		return item
	})
	newWineList = newWineList.set('wines', updater)
	return newWineList.toJS()
}

export const getWineList = (filter = initWineListFilter, page, perPage) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.wineListFailure)
        dispatch(wineActions.wineListReq())
        let wineList = await api.getWineList(filter, page, perPage)
        let memberWineIds = wineList.wines.flatMap(item => item.storageMemberWine.flatMap(memberWine => memberWine.memberWineId))
        let latestActivity = await api.getWinesLatestActivity(memberWineIds)
        const memberWineNoteMap = fromJS(getMemberWineNoteMap(latestActivity))
        dispatch(wineActions.wineLatestActivitySuccess(memberWineNoteMap))
        dispatch(wineActions.wineListSuccess(wineList))
    }
}

export const getWineData = (cwWineId, volume) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.getWineDataFailure)
        dispatch(wineActions.getWineDataReq())
        let wine = await api.getWineData(cwWineId, volume)
        dispatch(wineActions.getWineDataSuccess(wine))
    }
}

export const getCellarStats = (cellarId) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.cellarStatsFailure)
        dispatch(wineActions.cellarStatsReq())
        let stats = await api.getCellarStats(cellarId)
        dispatch(wineActions.cellarStatsSuccess(stats))
    }
}

export const createReservation = (reservation) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.wineReservationFailure)
        dispatch(wineActions.wineReservationReq())
        await api.createReservation(reservation)
        dispatch(wineActions.wineReservationSuccess())
    }
}

export const updateCwWineNote = (wineId, comment, cwWineId, volume) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.updateCwWineNoteFailure)
        dispatch(wineActions.updateCwWineNoteReq())
        await api.updateCwWineNote(wineId, comment)
        dispatch(getWineData(cwWineId, volume))
    }
}

export const updateMemberWine = (query) => {
    const { memberWineId, quantity, cost, currency, note, cwWineId, volume } = query
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, wineActions.updateWineInfoFailure)
        dispatch(wineActions.updateWineInfoReq())
        let res  = await api.updateMemberWine(memberWineId, quantity, cost, currency, note)
        dispatch(getWineData(cwWineId, volume))
        
        let latestActivity = await api.getWinesLatestActivity([res.memberWineId])
        const memberWineNoteMap = fromJS(getMemberWineNoteMap(latestActivity))
        dispatch(wineActions.wineLatestActivitySuccess(memberWineNoteMap))
    }
}